<script>
import { app } from "@/main";
import { authComputed } from "@/state/helpers";

/**
 * Nav-bar Component
 */
export default {
  data() {
    return {};
  },
  components: {},
  computed: {
    ...authComputed,
  },
  mounted() {},
  methods: {
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    logoutUser() {
      app.$store.commit("auth/logout");
    },
    getUserName() {
      let userFullName = "Not Defined";
      if (this.loggedInUser.first_name && this.loggedInUser.last_name) {
        userFullName = `${this.loggedInUser.first_name} ${this.loggedInUser.last_name}`;
      } else if (this.loggedInUser.first_name) {
        userFullName = `${this.loggedInUser.first_name}`;
      }
      return userFullName;
    },
  },
};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <router-link tag="a" to="/" class="logo logo-dark">
            <span class="logo-sm">
              <img
                src="@/assets/images/brickbin-logo-small.png"
                alt
                height="44"
              />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/brickbin-logo.png" alt height="17" />
            </span>
          </router-link>

          <router-link tag="a" to="/" class="logo logo-light">
            <span class="logo-sm">
              <img
                src="@/assets/images/brickbin-logo-small.png"
                alt
                height="22"
              />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/brickbin-logo.png" alt height="60" />
            </span>
          </router-link>
        </div>

        <button
          id="vertical-menu-btn"
          type="button"
          class="btn btn-sm px-3 font-size-16 header-item"
          @click="toggleMenu"
        >
          <i class="fa fa-fw fa-bars"></i>
        </button>
      </div>

      <div class="d-flex">
        <b-dropdown
          right
          variant="black"
          toggle-class="header-item"
          menu-class="dropdown-menu-end"
        >
          <template v-slot:button-content>
            <div class="d-flex align-items-center">
              <div class="d-flex flex-column">
                <span class="d-none d-xl-inline-block ms-1">
                  {{ getUserName() }}
                </span>
                <span class="small">{{ loggedInUser.email }}</span>
              </div>
              <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
            </div>
          </template>
          <b-link
            :to="{
              name: 'user-edit',
              params: { id: loggedInUser.id },
            }"
            class="dropdown-item"
          >
            <i class="bx bx-user font-size-16 align-middle me-1"></i>
            Account
          </b-link>
          <a href="/logout" class="dropdown-item text-danger">
            <i
              class="bx bx-power-off font-size-16 align-middle me-1 text-danger"
            ></i>
            Logout
          </a>
        </b-dropdown>
      </div>
    </div>
  </header>
</template>
